<template>
  <div class="searchResult">
    <div class="title">
      <van-nav-bar title="消息"
                   left-arrow
                   @click-left="onClickLeft" />
    </div>

    <div class="list_conts">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="已加载完全部数据"
                @load="onLoadList">
        <ul v-for="(item,index) in list"
            :key="index"
            class="list_cont"
            @click="goDetail(item)">
          <li>
            <span v-if="item.messageTitle === '已开方'"
                  class="img"><img src="../../icons/kaifang.png"></span>
            <span v-if="item.messageTitle === '已审核'"
                  class="img"><img src="../../icons/shenhe.png"></span>
            <span v-if="item.messageTitle === '审核不通过'"
                  class="img"><img src="../../icons/no.png"></span>

            <span class="newlist">
              <span class="newstatus">
                <!-- 显示 已开方 已审核 审核被驳回 -->
                <span class="status">{{ item.messageTitle }}</span>
                <!-- <span v-if=" tranStatus( item.prescriptionStatus,item.prescriptionAuditStatus)==4" class="status">已开方</span>
                <span v-if=" tranStatus( item.prescriptionStatus,item.prescriptionAuditStatus)==2" class="status">已审核</span>
                <span v-if=" tranStatus( item.prescriptionStatus,item.prescriptionAuditStatus)==3" class="status">审核被驳回</span> -->

                <!-- <span>{{ item.status }}</span> -->
                <span class="createTime">{{ item.createTime }}</span>
              </span>
              <span class="preNo">{{ item.messageInfo }}</span>
            </span>
          </li>
        </ul>
      </van-list>
    </div>
  </div>
</template>
<script>
import { getMessageList, getMessageListReaded } from '../../api/index'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      selectIcon: false,
      finished: false, // 数据全部加载完成
      loading: false, // 加载状态是否结束,为true表示正在加载中
      list: []
    }
  },
  computed: {
    // 转换状态
    tranStatus () {
      return function (prescriptionStatus, prescriptionAuditStatus) {
        let showStatus
        let showAuditStatus
        if (prescriptionStatus === 4) {
          showStatus = '4'
          // showStatus = (readStatus === 4 ? '1' : '')
          return showStatus
          // return 后，后边else if就不再执行
        } else if (prescriptionAuditStatus === 2 || prescriptionAuditStatus === 3) {
          showAuditStatus = (prescriptionAuditStatus === 2 ? '2' : '3')
          return showAuditStatus
        }
      }
    }

  },
  created () {
    // 把vuex中的消息数量置0
    window.location.href = `protocol://action/clear_notification`
    setTimeout(() => {
      // 隐藏底部栏
      window.location.href = 'protocol://action/hideBottomTab'
    }, 500)
    this.$store.dispatch('getnews', 'clear')
  },
  methods: {
    async onLoadList () {
      try {
        const res = await getMessageList({ pageNum: this.pageNum, pageSize: 10 })
        //
        console.log('消息', res)

        if (res.pageNum > 1) {
          this.list = [...this.list, ...res.list]
        } else {
          this.list = res.list
        }
        this.loading = false
        await getMessageListReaded({})
        // console.log('read', resread)
        // console.log('this.list', this.list)
        if (res.hasNextPage) {
          this.pageNum++
          // console.log('this.pa', this.pageNum)
        } else {
          this.finished = true
        }
      } catch (error) {
        console.error(error)
      }
    },
    onClickLeft () {
      // 把vuex中的消息数量置0
      this.$store.dispatch('getnews', 'clear')
      this.$router.push({ path: 'home' })
    },
    goDetail (item) {
      // 把vuex中的消息数量置0
      try {
        this.$store.dispatch('getnews', 'clear')
        this.$router.push({
          path: 'waitpre',
          query: { guid: item.messageGuid, type: 'record' }
        })
      } catch (error) {
        console.log(error)
      }
    }

  }

}
</script>
<style scoped>
/* .searchResult {background:rgba(247,247,247,1);} */
/* .searchResult {background: darkgray;} */
.searchResult {
  background: #f7f7f7;
}
.title {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.list_conts {
  margin-top: 64px;
}
.van-list ul:nth-of-type(1) {
  margin-top: 10px;
}

.searchResult /deep/.van-nav-bar {
  color: #666666;
  height: 64px;
}
.van-nav-bar .van-icon {
  color: #666666;
  width: 10px;
  height: 18px;
  vertical-align: super;
}
.van-nav-bar__title {
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-size: 18px;
  font-weight: 550;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.van-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.list_cont {
  width: 345px;
  height: 75px;
  background: #fff;
  border-radius: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.list_cont li {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  width: 335px;
}
/* 下边待会删除 */
.list_cont li img {
  width: 40px;
  height: 40px;
}
.list_cont li .img {
  width: 40px;
  height: 40px;
}

.newstatus {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
}
.newlist {
  width: 280px;
}
.preNo {
  font-size: 14px;
  color: #666666;
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-weight: 400;
}
/* .newstatus span:nth-of-type(1){color: #333;font-size: 15px;font-weight: Medium; font-family:"Microsoft YaHei",微软雅黑;font-weight:550;} */
.status {
  color: #333;
  font-size: 15px;
  font-weight: Medium;
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-weight: 550;
}

.createTime {
  color: #999999;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Microsoft YaHei', 微软雅黑;
  font-weight: 550;
}
</style>
